import { useSelector } from "react-redux"
import { IStoreState } from "../redux/initialStoreState"

export const useInsurerCodeId = () => {
    return useSelector((storeState: IStoreState) => 1);
}